import {
  FiActivity,
  FiAward,
  FiBookOpen,
  FiBox,
  FiBriefcase,
  FiCheckCircle,
  FiClock,
  FiCompass,
  FiCpu,
  FiDatabase,
  FiDroplet,
  FiGlobe,
  FiHeart,
  FiLayers,
  FiMapPin,
  FiPackage,
  FiRadio,
  FiSettings,
  FiShield,
  FiTarget,
  FiThermometer,
  FiTruck,
  FiUsers,
  FiZap,
} from "react-icons/fi";

const iconRules = [
  [/(pharma|hospital|healthcare|medical)/i, FiHeart],
  [/(automotive|vehicle|delivery|pick up|pickup|transport)/i, FiTruck],
  [/(aerospace|aviation)/i, FiCompass],
  [/(food|beverage|liquid|pipette|burette|flask|cylinder|volume)/i, FiDroplet],
  [/(temperature|thermal|thermo|humidity|furnace|freezer|oven|incubator|chamber|rtd|prt)/i, FiThermometer],
  [/(electrical|voltage|current|power|energy|multimeter|ammeter|voltmeter|ohm|battery|lcr|insulation|earth tester)/i, FiZap],
  [/(pressure|vacuum|pneumatic|hydraulic|magnehelic)/i, FiActivity],
  [/(dimensional|vernier|caliper|calliper|micrometer|gauge block|slip gauge|measuring tape|measuring scale|height gauge|depth gauge|dial gauge|bore gauge)/i, FiTarget],
  [/(mass|weight|weighing|balance)/i, FiPackage],
  [/(on-site|onsite|local support|pune)/i, FiMapPin],
  [/(nationwide|pan india|across india|international|national traceability)/i, FiGlobe],
  [/(turnaround|schedule|reminder|in-time|duration|timely)/i, FiClock],
  [/(engineer|customer support|responsive|experienced|team)/i, FiUsers],
  [/(modern|equipment|digital|oscilloscope|data logger|scanner|generator|counter|analyzer|controller)/i, FiCpu],
  [/(research|education|institution|knowledge)/i, FiBookOpen],
  [/(laboratory|testing lab|testing laboratories)/i, FiActivity],
  [/(nabl|accredit|certificate|quality|compliance|traceab|reliable|accuracy|safety|confidence)/i, FiAward],
  [/(manufacturing|engineering|process|force|hardness|impact|extensometer|machine)/i, FiSettings],
  [/(electronics|signal|frequency|radio)/i, FiRadio],
  [/(industry|industries|solution|service)/i, FiBriefcase],
  [/(surface|coating|layer|thickness)/i, FiLayers],
  [/(standard|reference|database|acquisition)/i, FiDatabase],
  [/(instrument|device|meter|tester|calibrator)/i, FiBox],
  [/(assurance|protection|risk)/i, FiShield],
];

export const getCalibrationIcon = (label = "") => {
  const match = iconRules.find(([pattern]) => pattern.test(label));
  return match ? match[1] : FiCheckCircle;
};

export const CalibrationPointIcon = ({ label, className = "" }) => {
  const Icon = getCalibrationIcon(label);

  return <Icon className={className} aria-hidden="true" />;
};

